import { Input } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { BodyCopyMedium } from '../../components/common/styles/globalStyles';
import ContentConstants from '../../contentConstants';
import { IHasValidationModel, SeverityType } from '../../models';
import { ValidationCollectionHelper } from '../../utilities';
import { Col3Col9, SeverityDisplay } from '../common';

export const MinNLabel = styled.label.attrs<{}>({
	className: 'tws-min-n-label',
})`
	margin-right: 10px;
`;
MinNLabel.displayName = 'MinNLabel';

export const MinNInputContainer = styled.div.attrs<{}>({
	className: 'tws-min-n-input-container',
})`
	display: inline-block;
	margin-right: 30px;
	width: 60px;
`;
MinNInputContainer.displayName = 'MinNInputContainer';

export const MinNOverrideContainer = styled.div.attrs<{}>({
	className: 'tws-min-n-override-container',
})`
	display: inline-block;
`;
MinNOverrideContainer.displayName = 'MinNOverrideContainer';

export interface IMinNProps extends IHasValidationModel {
	clientMinN: number | undefined;
	readOnly?: boolean;
	surveyMinN: number | undefined;
	MinNChange: (minN: number) => void;
}

export class MinN extends React.PureComponent<IMinNProps> {
	constructor(props: IMinNProps) {
		super(props);
		this.handleMinNChange = this.handleMinNChange.bind(this);
	}

	public render() {
		const { readOnly, surveyMinN, validationResults } = this.props;
		const validationHelper = new ValidationCollectionHelper(validationResults);
		return (
			<>
				<Col3Col9
					label={ContentConstants.SUBSECTIONHEADERS_REPORTING_MIN_N}
					labelInfoTitle={ContentConstants.INFOICON_TITLE_MIN_N}
					labelInfo={ContentConstants.INFOICON_DESCRIPTION_MIN_N}
				>
					{readOnly === true ? (
						<>
							<BodyCopyMedium>{surveyMinN}</BodyCopyMedium>
						</>
					) : (
						<>
							<BodyCopyMedium>{ContentConstants.INSTRUCTIONALTEXT_REPORTING_MIN_N}</BodyCopyMedium>
							<MinNLabel>{ContentConstants.SURVEY_MIN_N}</MinNLabel>
							<MinNInputContainer>
								<Input
									error={!validationHelper.IsValid('SurveyMinN')}
									maxLength={3}
									onChange={this.handleMinNChange as any}
									value={this.props.surveyMinN?.toString()}
								/>
							</MinNInputContainer>
							<MinNLabel>{ContentConstants.CLIENT_MIN_N}</MinNLabel>
							<MinNInputContainer>
								<Input disabled={true} maxLength={3} value={this.props.clientMinN?.toString()} />
							</MinNInputContainer>
							{/* 
							An error message is being rendered here instead of 
							using the message prop on the input above due to design. 
						*/}
							{this.getErrorMessage(validationHelper)}
						</>
					)}
				</Col3Col9>
			</>
		);
	}

	public handleMinNChange(value: number) {
		if (this.props.MinNChange) {
			this.props.MinNChange(value);
		}
	}

	// A SeverityDisplay is being rendered instead of the MessageHelper
	// due to the message needing to show in bold the error prefix.
	private getErrorMessage(validationHelper: ValidationCollectionHelper<any>) {
		if (!validationHelper.IsValid('SurveyMinN')) {
			return (
				<SeverityDisplay
					severity={SeverityType.Error}
					message={validationHelper.Errors('SurveyMinN').toString()}
					showSeverityPrefix={true}
				/>
			);
		}
	}
}
